define('casino',['jquery', 'casino/navigation', 'all/footer'], function($, casinoNavigation, footer) {
	'use strict';

	return {
		preload: $.noop,
		load: function() {
			casinoNavigation.init();
			footer.pixelTrack('CASINO');
			$(footer.show);
		}
	};
});

